import React from 'react'
import styled, { css } from 'styled-components'

import { themeEstra } from 'src/styles/themeEstra'
import { clTransform } from 'src/utils/cloudinary'

interface Props {
  src: string
  fluid?: boolean
  alt?: string
  className?: string
  size?: number
  mobileSize?: number
  shadow?: boolean
  border?: boolean
  lazy?: boolean
}

export const Avatar: React.FC<Props> = ({
  src,
  size = 76,
  mobileSize,
  fluid,
  className,
  alt,
  shadow,
  border,
  lazy = true,
}) => {
  return (
    <Wrapper
      src={clTransform({ url: src })}
      width={size}
      height={size}
      fluid={fluid}
      className={className}
      alt={alt}
      shadow={shadow}
      border={border}
      size={size}
      mobileSize={mobileSize}
      loading={lazy ? 'lazy' : undefined}
    />
  )
}

const Wrapper = styled.img<Props>`
  border-radius: 100%;
  width: ${prop => prop.mobileSize || prop.size}px;
  height: ${prop => prop.mobileSize || prop.size}px;

  @media (min-width: ${themeEstra.bp.tablet}) {
    width: ${prop => prop.size}px;
    height: ${prop => prop.size}px;
  }

  ${props =>
    props.fluid &&
    css`
      max-width: 100%;
      height: auto;
    `}

  ${props =>
    props.shadow &&
    css`
      box-shadow: ${themeEstra.shadow.espansa};
    `}
    
    ${props =>
      props.border &&
      css`
        border: 1px solid ${themeEstra.color.neutri.grigioMedio};
      `}
`
